import { Grid, Stack, Typography } from '@mui/material';

import { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as CloseIcon } from 'common/assets/images/close.svg';
import ButtonComp from 'common/components/Button/ButtonComp';
import { HTTP_STATUS_CODES } from 'common/constants/HttpStatusConstants';
import { RootState } from 'common/store/AppStore';
import { setToastMessage } from 'common/store/reducer/commonReducer';
import { setIsReloadTableData } from 'common/store/reducer/promptBuilderReducer';

import { deletePrompt } from '../../api';

import actionStyles from '../PromptActions.module.scss';

interface IPromptDelete {
	closeDeleteModal: () => void;
}
const PromptDelete = (props: IPromptDelete) => {
	const dispatch = useDispatch();

	const { closeDeleteModal } = props;

	const { OK } = HTTP_STATUS_CODES;

	const [isLoading, setIsLoading] = useState<boolean>(false);

	const selectedPromptData: any = useSelector(
		(state: RootState) => state.promptBuilder.selectedPrompt,
	);

	const handleDeleteAction = async () => {
		setIsLoading(true);
		const res = await deletePrompt(selectedPromptData?.key);
		if (res?.statusCode === OK) {
			setIsLoading(false);
			dispatch(
				setToastMessage({
					message: `Successfully deleted the prompt "${selectedPromptData?.key}" from the library`,
					severity: 'success',
					isToastOpen: true,
				}),
			);
			dispatch(setIsReloadTableData(true));
			closeDeleteModal();
		} else {
			const { errorBody } = res;
			const responseError: any = res.error;
			const errorMessage =
				(errorBody?.error as string) || (responseError?.message as string);
			dispatch(
				setToastMessage({
					message: errorMessage,
					severity: 'error',
					isToastOpen: true,
				}),
			);
			setIsLoading(false);
		}
	};

	return (
		<Grid
			container
			direction="column"
			spacing={2}
			sx={{ width: '100%', boxSizing: 'border-box' }}
		>
			<Stack
				className={actionStyles['prompt-modal-title-container']}
				onClick={(event) => event.stopPropagation()}
				data-testid="title-container"
			>
				<Grid item>
					<Typography className={actionStyles['prompt-modal-title']}>
						Delete prompt?
					</Typography>
				</Grid>
				<CloseIcon
					fontSize="medium"
					onClick={closeDeleteModal}
					className={actionStyles['prompt-modal-close']}
					data-testid="close-icon"
				/>
			</Stack>
			<Grid item>
				<Typography className={actionStyles['prompt-modal-warning']}>
					Are you sure you want to delete{' '}
					<b>&quot;{selectedPromptData?.key}&quot;</b> prompt? This action will
					permanently delete the item.
				</Typography>
			</Grid>
			<Grid item>
				<Grid container justifyContent="flex-end" spacing={2}>
					<Grid item>
						<ButtonComp
							btnType="secondary"
							onClick={closeDeleteModal}
							data-testid="cancel-dialog-btn"
						>
							Cancel
						</ButtonComp>
					</Grid>
					<Grid item>
						<ButtonComp
							btnType="primary"
							loading={isLoading}
							onClick={handleDeleteAction}
							data-testid="delete-dialog-btn"
						>
							Delete
						</ButtonComp>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default PromptDelete;
